import styled, { css } from 'styled-components';

const inputBase = css<{ hasError?: boolean }>`
    width: 100%;
    border-radius: ${({ theme }) => theme.form.input.borderRadius};
    border: 1px solid ${({ theme, hasError }) => (hasError ? theme.color.error.main : theme.color.grey.light)};
    font-family: ${({ theme }) => theme.font};
    font-size: 14px;
    color: ${({ theme }) => theme.color.text.main};
    padding: 8px;
    box-sizing: border-box;
    outline: none;

    &:focus {
        border-color: ${({ theme }) => theme.color.primary.main};
    }
`;

export const SField = styled.div`
    margin-bottom: 1.6rem;
`;

export const SLabel = styled.label`
    display: block;
    font-size: 1.3rem;
    font-weight: 600;
    margin-bottom: 0.4rem;
    color: ${({ theme }) => theme.color.text.main};
`;

export const STextInput = styled.input<{ hasError?: boolean }>`
    ${inputBase}
    height: 4rem;
`;

export const STextarea = styled.textarea`
    ${inputBase}
    resize: vertical;
    min-height: 7rem;
`;

export const SPromptBox = styled.div`
    background-color: ${({ theme }) => theme.color.grey.lighter};
    border: 1px solid ${({ theme }) => theme.color.grey.light};
    border-radius: ${({ theme }) => theme.form.input.borderRadius};
    padding: 1.2rem;
    max-height: 28rem;
    overflow-y: auto;
    margin-bottom: 1.6rem;
`;

export const SPromptText = styled.pre`
    font-family: ${({ theme }) => theme.font};
    font-size: 1.3rem;
    line-height: 1.6;
    white-space: pre-wrap;
    word-break: break-word;
    margin: 0;
    color: ${({ theme }) => theme.color.text.main};
`;

export const SLlmLinks = styled.div`
    display: flex;
    gap: 1rem;
    margin-bottom: 1.2rem;
    flex-wrap: wrap;
`;

export const SLlmLink = styled.a`
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.8rem 1.6rem;
    border-radius: ${({ theme }) => theme.form.input.borderRadius};
    border: 1px solid ${({ theme }) => theme.color.primary.main};
    color: ${({ theme }) => theme.color.primary.main};
    font-family: ${({ theme }) => theme.font};
    font-size: 1.4rem;
    font-weight: 600;
    text-decoration: none;
    transition: background-color 0.15s, color 0.15s;

    &:hover {
        background-color: ${({ theme }) => theme.color.primary.main};
        color: ${({ theme }) => theme.color.white};
    }
`;

export const SHint = styled.p`
    font-size: 1.3rem;
    color: ${({ theme }) => theme.color.grey.light};
    margin-bottom: 1rem;
`;

export const SStepTitle = styled.p`
    font-size: 1.5rem;
    font-weight: 600;
    color: ${({ theme }) => theme.color.text.main};
    margin-bottom: 0.6rem;
`;
